import translations from '../../components/TrustList/TrustList.translations'

export const warrantyItem = ({ warrantyDuration }) => {
  return {
    id: 'reassurance_service_warranty',
    icon: 'IconFast',
    i18n: {
      translation: translations.warranty,
      params: { warrantyDuration },
    },
  }
}
